import React from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

const TestimonialFour = () => {
    return(
        <>
        {/* Testimonial Section */}
        <section className="testimonial-section-two section-padding-six">
            <div className="default-container">
            <div className="row clearfix">
                <div className="col-lg-6">
                <div className="testimonial-two-img">
                    <img src="images/testimonial/testi-img-01.png" alt="testimonial" />
                </div>
                </div>
                <div className="col-lg-6">
                <div className="row clearfix">
                    <div className="col-lg-12">
                    <div className="sec-o-title text-left pb-3">
                        <h2 className="transform-uppercase">Clients <span>Review</span></h2>
                    </div>
                    </div>
                    <div className="con-title-column col-lg-12">
                    <OwlCarousel 
                        items={1}
                        loop={true}
                        nav={true}
                        dots={true}
                        autoplay={true}
                        animateIn={'fadeIn'}
                        animateOut={'fadeOut'}
                        navText={['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>']}
                        className="text-left single-item-carousel owl-carousel">
                        <div className="business-client-box mt-0">
                        <div className="client-box-img mb-3 mx-left">
                            <img src="images/testimonial/ts-01-120x120.png" alt="" className="img-fluid rounded-circle" />
                        </div>
                        <div className="clients-name">
                            <h5 className="mb-0 text-uppercase font-weight-bold">Dan Gibson</h5>
                            <small className="text-uppercase">Business Client</small>
                        </div>
                        <p className="text pt-1 mx-auto">Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat vitae, ultricies eget, tempor sit amet, ante. Donec eu libero sit amet quam egestas semperzz.
                            Aenean ultricies mi vitae est. </p>
                        </div>
                        <div className="business-client-box mt-0">
                        <div className="client-box-img mb-3 mx-left">
                            <img src="images/testimonial/ts-02-120x120.png" alt="" className="img-fluid rounded-circle" />
                        </div>
                        <div className="clients-name">
                            <h5 className="mb-0 text-uppercase font-weight-bold">Dan Gibson</h5>
                            <small className="text-uppercase">Business Client</small>
                        </div>
                        <p className="text pt-1 mx-auto">Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat vitae, ultricies eget, tempor sit amet, ante. Donec eu libero sit amet quam egestas semperzz.
                            Aenean ultricies mi vitae est. </p>
                        </div>
                        <div className="business-client-box mt-0">
                        <div className="client-box-img mb-3 mx-left">
                            <img src="images/testimonial/ts-03-120x120.png" alt="" className="img-fluid rounded-circle" />
                        </div>
                        <div className="clients-name">
                            <h5 className="mb-0 text-uppercase font-weight-bold">Dan Gibson</h5>
                            <small className="text-uppercase">Business Client</small>
                        </div>
                        <p className="text pt-1 mx-auto">Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat vitae, ultricies eget, tempor sit amet, ante. Donec eu libero sit amet quam egestas semperzz.
                            Aenean ultricies mi vitae est. </p>
                        </div>
                    </OwlCarousel>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </section>
        {/* End Testimonial Section */}
        </>
    )
}

export default TestimonialFour;